/* eslint-disable */
import _ from 'lodash'
import {Request} from '../shared/base.requests'
import config from '../../config/customer.api'
import { mapActions } from 'vuex';

const videoMessageModule = {
    namespaced: true,
    state: {
        videoMessages:[],
        selectedVideoMessage:undefined
    },
    mutations: {
        setVideoMessages (state, payload) {
            state.videoMessages = payload;    
        },
        setSelectedVideoMessage (state, payload) {
            state.selectedVideoMessage = payload;    
        }
    },
    actions: {
        loadVideoMessages: function (context,payload) {       
        return new Promise((resolve, reject) => {
            Request.get(config.videoMessages)
                .then(response => {           
                    context.commit('setVideoMessages', response);
                    resolve();
                })
                .catch(error => {
                    console.error('setMakes failed', error);
                    reject()
                })
            })
        },
        loadSelectedVideoMessage: function (context,payload) { 
        return new Promise((resolve, reject) => {
            Request.get(config.selectVideoMessage+"?messageId="+payload)
                    .then(response => {
                        context.commit('setSelectedVideoMessage', response);        
                        resolve();
                    })
                    .catch(error => {
                        console.error('setCustomer failed', error);
                        reject()
                    })
            })
        },
        setVideoMessagePlaysMetric: function (context, payload) { 
            return new Promise((resolve, reject) => {
                Request.get(config.setPlays + "?messageId=" + payload)
                    .then(response => {
                        resolve();
                    })
                    .catch(error => {
                        console.error('setVideoMessagePlaysMetric failed', error);
                        reject()
                    })
            })
        },
        setVideoMessageBackgroundViewsMetric: function (context, payload) { 
            return new Promise((resolve, reject) => {
                Request.get(config.setBackgroundViews + "?messageId=" + payload)
                    .then(response => {
                        resolve();
                    })
                    .catch(error => {
                        console.error('setVideoMessageBackgroundViewsMetric failed', error);
                        reject()
                    })
            })
        }
    },
    getters: {
        getVideoMessages: state => {
            return state.videoMessages;
        },
        getSelectedVideoMessage: state => {
            return state.selectedVideoMessage;
        }        
    },   
}

export default videoMessageModule;



// WEBPACK FOOTER //
// ./scripts/src/store/video.message.module.js